/**
 * Branding config — controls operator-facing name.
 *
 * OPERATOR_NAME: the name shown in header/login (configurable per demo instance).
 * PRODUCT_NAME: always "FrostyPilots" (used in "Powered by" footer).
 */

export const OPERATOR_NAME = import.meta.env.VITE_OPERATOR_NAME || 'FrostyPilots';
export const PRODUCT_NAME = 'FrostyPilots';
